import { useCallback, useEffect, useRef, useState } from 'react'
import {
    apiGetListPartner,
    apiGetListPackageDataSponsorPartner,
    apiGetListPackageDataCodesPartner,
    apiGetListNetworkProvider,
} from '../../api'
import { Tabs, TabsProps, Card, Row, Col, Typography, Select, Button, Tag, Space } from 'antd'
import { EditOutlined, EyeOutlined, PercentageOutlined, TeamOutlined, GiftOutlined, ReloadOutlined } from '@ant-design/icons'
import { PartnerList } from '../../interfaces/list-partner.interface'
import { useLoading } from '../../context/LoadingContext'
import { toast } from 'react-toastify'
import { Link, useSearchParams } from 'react-router-dom'
import { mapCompanyAccounts } from '../../assets/constants/constants'
import { formatCurrency } from '../../utils/string-utils'
import ViewPartnerSponsor from './ViewPartnerSponsor'
import { CREATE_PARTNER_CODE, CREATE_PARTNER_SPONSOR, CREATE_PARTNER_SPONSOR_PROMOTION, EDIT_PARTNER_CODE, EDIT_PARTNER_SPONSOR, PACKAGE_MANAGEMENT, PARTNERS } from '../../assets/constants/route_path'
import {partnerPackageStatusOptions, providerTDMsourceOptions} from '../../assets/constants/default_option'
import ViewPartnerCode from './ViewPartnerCode'

const { Title, Text } = Typography;

const initCustomer = {
    partners: [],
    total: 0,
}

export default function PackageManagement() {
    const [sponsors, setSponsors] = useState<any>({})
    const [selectedCustomerDataSponsor, setSelectedCustomerDataSponsor] = useState<number>(0)
    const selectSponsorRef = useRef(null)
    const [modalViewSponsor, setModalViewSponsor] = useState<{ data: any, isOpen: boolean }>({
        data: null,
        isOpen: false,
    })
    const [listSponsors, setListSponsors] = useState([])
    const [promotionType, setPromotionType] = useState('')
    const [networkType, setNetworkType] = useState('')
    const [statusType, setStatusType] = useState('')

    useEffect(() => {
        const listPackages = sponsors?.packages
        const listSponsors = listPackages?.map((item: any) => {
            item.promotion = 'No'
            if (item.parentId === 0) {
                for (let i = 0; i < listPackages?.length; i++) {
                    if (listPackages[i].parentId === item.ID) {
                        item.promotion = 'Yes'
                        break
                    }
                }
                return item
            }
            for (let i = 0; i < listPackages?.length; i++) {
                if (listPackages[i].ID === item.parentId) {
                    item.parentName = listPackages[i].name
                    break
                }
            }
            return item
        })
        const results = listSponsors?.sort((a: any, b: any) => new Date(b.CreatedAt)?.getTime() - new Date(a.CreatedAt)?.getTime())
            .filter((item: any) => {
                if (promotionType) {
                    return item.promotion === promotionType
                }
                return true
            })
            .filter((item: any) => {
                if (networkType === 'All') {
                    return item.network === '' || item.network === 'All'
                }
                if (networkType) {
                    return item.network === networkType
                }
                return true
            })
            .filter((item: any) => {
                if (statusType) {
                    return item.status === statusType
                }
                return true
            })
        setListSponsors(results)
    }, [sponsors?.packages, promotionType, networkType, statusType])

    const [codes, setCodes] = useState<any>({})
    const [selectedCustomerDataCode, setSelectedCustomerDataCode] = useState<number>(0)
    const selectCodeRef = useRef(null)
    const [modalViewCode, setModalViewCode] = useState<{ data: any, isOpen: boolean }>({
        data: null,
        isOpen: false,
    })
    const [listCodes, setListCodes] = useState([])
    const [statusTypeCode, setStatusTypeCode] = useState('')

    useEffect(() => {
        const dataCodes = codes?.dataCodes
        if (!dataCodes) {
            setListCodes([])
            return
        }

        const results = dataCodes
            .filter((item: any) => {
                if (statusTypeCode) {
                    return item.status === statusTypeCode
                }
                return true
            })
            .sort((a: any, b: any) => {
                const dateA = new Date(a.CreatedAt).getTime()
                const dateB = new Date(b.CreatedAt).getTime()
                return dateB - dateA
            })

        setListCodes(results)
    }, [codes?.dataCodes, statusTypeCode])

    const { setIsLoading } = useLoading()
    const [searchParams] = useSearchParams()
    const previousCpCode = searchParams.get('cpCode')
    const previousTab = searchParams.get('previousTab')
    const [customers, setCustomers] = useState<PartnerList>(initCustomer)
    const [networks, setNetworks] = useState<any>([])
    const [defaultCpCode, setDefaultCpCode] = useState('')

    const fetchApiGetListPartner = useCallback(async () => {
        try {
            const resCustomers = await apiGetListPartner()
            if (resCustomers.data.partners != null) {
                resCustomers.data.partners = resCustomers.data.partners.filter((item: any) => !mapCompanyAccounts[item.cpCode])
                setCustomers(resCustomers.data)
                handleGetListPackagePartnerPrevious(resCustomers.data.partners)
            } else {
                setCustomers(initCustomer)
            }
        } catch (error) {
            console.log(error)
        }
    }, [setIsLoading])

    const fetchApiGetListNetworkProvider = useCallback(async () => {
        try {
            const respListNetworks = await apiGetListNetworkProvider()
            if (respListNetworks.data?.networks != null) {
                const listNetworks = respListNetworks.data.networks.map((net: any) => ({ label: net.name, value: net.name }))
                setNetworks(listNetworks)
            }
        } catch (error) {
            console.log(error)
        }
    }, [setIsLoading])

    const handleGetListPackagePartnerPrevious = (partners: any) => {
        if (previousCpCode && previousTab) {
            const previousPartner = partners.findIndex((item: any) => item['cpCode'] === previousCpCode)
            switch (`${previousCpCode}_${previousTab}`) {
                case `${previousCpCode}_dataSponsor`:
                    setSelectedCustomerDataSponsor(previousPartner)
                    checkPartnerDataSponsor()
                    break;
                case `${previousCpCode}_dataCode`:
                    setSelectedCustomerDataCode(previousPartner)
                    checkPartnerDataCode()
                    break;
                default:
                    break;
            }
        } else {
            setDefaultCpCode(partners[0].cpCode)
        }
    }

    useEffect(() => {
        fetchApiGetListNetworkProvider()
        fetchApiGetListPartner()
        if (!previousCpCode && defaultCpCode) {
            checkPartnerDataSponsor()
            checkPartnerDataCode()
        }
    }, [previousCpCode, defaultCpCode])

    const checkPartnerDataSponsor = async () => {
        const cpCode = customers.partners[Number(selectedCustomerDataSponsor)]?.cpCode ?? ''
        if (!cpCode && !previousCpCode && !defaultCpCode) {
            toast.error('Vui lòng chọn đối tác')
        }
        try {
            setIsLoading(true)
            const resSponsors = await apiGetListPackageDataSponsorPartner({ cpCode: cpCode || previousCpCode || defaultCpCode })
            if (resSponsors.data.packages != null) {
                setSponsors(resSponsors.data)
            } else {
                setSponsors({})
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            console.log(error)
        }
    }
    const clearEventSponsor = () => {
        setSponsors({})
        setSelectedCustomerDataSponsor(0)
        setPromotionType('')
        setNetworkType('')
        setStatusType('')
    }

    const checkPartnerDataCode = async () => {
        const cpCode = customers.partners[Number(selectedCustomerDataCode)]?.cpCode ?? ''
        if (!cpCode && !previousCpCode && !defaultCpCode) {
            toast.error('Vui lòng chọn đối tác')
        }
        try {
            setIsLoading(true)
            const resCodes = await apiGetListPackageDataCodesPartner({ cpCode: cpCode || previousCpCode || defaultCpCode })
            if (resCodes.data.dataCodes != null) {
                setCodes(resCodes.data)
            } else {
                setCodes({})
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            console.log(error)
        }
    }
    const clearEventCode = () => {
        setCodes({})
        setSelectedCustomerDataCode(0)
        setStatusTypeCode('')
    }

    const renderSponsorCard = (sponsor: any, index: number) => (
        <Card
            key={sponsor.id || index}
            style={{
                marginBottom: 16,
                border: '1px solid #f0f0f0',
                borderRadius: 8
            }}
        >
            <Row justify="space-between" align="top">
                <Col span={24}>
                    <div style={{ marginBottom: 12 }}>
                        <Row justify="space-between" align="middle">
                            <Col>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 32,
                                        height: 32,
                                        borderRadius: '50%',
                                        backgroundColor: '#52c41a',
                                        color: 'white',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontWeight: 'bold',
                                        fontSize: '14px'
                                    }}>
                                        {index + 1}
                                    </div>
                                    <div>
                                        <Title level={5} style={{ margin: 0, marginBottom: 4 }}>
                                            {sponsor.name}
                                        </Title>
                                        <Text type="secondary">
                                            {sponsor.cpCode} • {sponsor.dataPack}
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <Row gutter={24} style={{ marginBottom: 16 }}>
                        <Col span={4}>
                            <div>
                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>DISCOUNT</Text>
                                <div style={{ marginTop: 4 }}>
                                    <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                        {Number(sponsor.discount).toFixed(2)}
                                    </Text>
                                </div>
                            </div>
                        </Col>
                        <Col span={4}>
                            <div>
                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>GIÁ</Text>
                                <div style={{ marginTop: 4 }}>
                                    <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                        {formatCurrency(sponsor.price)}
                                    </Text>
                                </div>
                            </div>
                        </Col>
                        <Col span={4}>
                            <div>
                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>ĐƠN GIÁ</Text>
                                <div style={{ marginTop: 4 }}>
                                    <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                        {formatCurrency(sponsor.priceUnit)}
                                    </Text>
                                </div>
                            </div>
                        </Col>
                        <Col span={4}>
                            <div>
                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>NHÀ CUNG CẤP</Text>
                                <div style={{ marginTop: 4 }}>
                                    <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                        {sponsor.network || 'All'}
                                    </Text>
                                </div>
                            </div>
                        </Col>
                        <Col span={4}>
                            <div>
                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>KHUYẾN MÃI</Text>
                                <div style={{ marginTop: 4 }}>
                                    <Tag color={sponsor.promotion === 'Yes' ? 'green' : 'red'} style={{ fontSize: '11px' }}>
                                        {sponsor.promotion}
                                    </Tag>
                                </div>
                            </div>
                        </Col>
                        <Col span={4}>
                            <div>
                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>TRẠNG THÁI</Text>
                                <div style={{ marginTop: 4 }}>
                                    <Tag color={sponsor.status === 'Active' ? 'green' : 'red'} style={{ fontSize: '11px' }}>
                                        {sponsor.status}
                                    </Tag>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginTop: 12,
                        padding: '12px',
                        backgroundColor: '#fafafa',
                        borderRadius: 6,
                        border: '1px solid #f0f0f0'
                    }}>
                        <div>
                            <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>THỜI GIAN TẠO</Text>
                            <div style={{ marginTop: 4 }}>
                                <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                    {sponsor.CreatedAt ? new Date(sponsor.CreatedAt).toLocaleString('vi-VN') : ''}
                                </Text>
                            </div>
                        </div>
                        <Space>
                            <Button
                                onClick={() => setModalViewSponsor({ data: sponsor, isOpen: true })}
                                style={{ color: 'white', background: 'gray' }}
                                icon={<EyeOutlined />}
                            >
                            </Button>
                            <Link to={PARTNERS + PACKAGE_MANAGEMENT + CREATE_PARTNER_SPONSOR_PROMOTION + `?cpCode=${sponsor.cpCode}&dataPack=${sponsor.dataPack}`}>
                                <Button style={{ color: 'white', background: 'red' }} icon={<GiftOutlined />}>
                                </Button>
                            </Link>
                            <Link to={PARTNERS + PACKAGE_MANAGEMENT + EDIT_PARTNER_SPONSOR + `?cpCode=${sponsor.cpCode}&dataPack=${sponsor.dataPack}`}>
                                <Button style={{ color: 'white', background: 'orange' }} icon={<EditOutlined />}>
                                </Button>
                            </Link>
                        </Space>
                    </div>
                </Col>
            </Row>
        </Card>
    )

    const renderCodeCard = (code: any, index: number) => (
        <Card
            key={code.id || index}
            style={{
                marginBottom: 16,
                border: '1px solid #f0f0f0',
                borderRadius: 8
            }}
        >
            <Row justify="space-between" align="top">
                <Col span={24}>
                    <div style={{ marginBottom: 12 }}>
                        <Row justify="space-between" align="middle">
                            <Col>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 32,
                                        height: 32,
                                        borderRadius: '50%',
                                        backgroundColor: '#1890ff',
                                        color: 'white',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontWeight: 'bold',
                                        fontSize: '14px'
                                    }}>
                                        {index + 1}
                                    </div>
                                    <div>
                                        <Title level={5} style={{ margin: 0, marginBottom: 4 }}>
                                            {code.dataCode}
                                        </Title>
                                        <Text type="secondary">
                                            {code.cpCode}
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <Row gutter={24} style={{ marginBottom: 16 }}>
                        <Col span={6}>
                            <div>
                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>DISCOUNT</Text>
                                <div style={{ marginTop: 4 }}>
                                    <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                        {Number(code.discount).toFixed(2)}
                                    </Text>
                                </div>
                            </div>
                        </Col>
                        <Col span={6}>
                            <div>
                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>GIÁ</Text>
                                <div style={{ marginTop: 4 }}>
                                    <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                        {formatCurrency(code.price)}
                                    </Text>
                                </div>
                            </div>
                        </Col>
                        <Col span={6}>
                            <div>
                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>ĐƠN GIÁ</Text>
                                <div style={{ marginTop: 4 }}>
                                    <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                        {formatCurrency(code.priceUnit)}
                                    </Text>
                                </div>
                            </div>
                        </Col>
                        <Col span={6}>
                            <div>
                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>TRẠNG THÁI</Text>
                                <div style={{ marginTop: 4 }}>
                                    <Tag color={code.status === 'Active' ? 'green' : 'red'} style={{ fontSize: '11px' }}>
                                        {code.status}
                                    </Tag>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginTop: 12,
                        padding: '12px',
                        backgroundColor: '#fafafa',
                        borderRadius: 6,
                        border: '1px solid #f0f0f0'
                    }}>
                        <div>
                            <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>THỜI GIAN TẠO</Text>
                            <div style={{ marginTop: 4 }}>
                                <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                    {code.CreatedAt ? new Date(code.CreatedAt).toLocaleString('vi-VN') : ''}
                                </Text>
                            </div>
                        </div>
                        <Space>
                            <Button
                                onClick={() => setModalViewCode({ data: code, isOpen: true })}
                                style={{ color: 'white', background: 'gray' }}
                                icon={<EyeOutlined />}>
                            </Button>
                            <Link to={PARTNERS + PACKAGE_MANAGEMENT + EDIT_PARTNER_CODE + `?cpCode=${code.cpCode}&dataCode=${code.dataCode}`}>
                                <Button
                                    style={{ color: 'white', background: 'orange' }}
                                    icon={<EditOutlined />}>
                                </Button>
                            </Link>
                        </Space>
                    </div>
                </Col>
            </Row>
        </Card>
    )

    const sponsorPackagesAll = sponsors.packages || []
    const codePackagesAll = codes.dataCodes || []
    const sponsorPackagesFiltered = listSponsors || []
    const codePackagesFiltered = listCodes || []

    const itemsTab: TabsProps['items'] = [
        {
            key: 'dataSponsor',
            label: 'Data sponsor',
            children: (
                <div>
                    <Row gutter={24} style={{ marginBottom: 24 }}>
                        <Col span={6}>
                            <Card>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 8,
                                        backgroundColor: '#e6f7ff',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <TeamOutlined style={{ color: '#1890ff', fontSize: '20px' }} />
                                    </div>
                                    <div>
                                        <Text type="secondary">Tổng số gói</Text>
                                        <div>
                                            <Title level={3} style={{ margin: 0, color: '#1890ff' }}>
                                                {sponsorPackagesAll.length}
                                            </Title>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 8,
                                        backgroundColor: '#f6ffed',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <TeamOutlined style={{ color: '#52c41a', fontSize: '20px' }} />
                                    </div>
                                    <div>
                                        <Text type="secondary">Gói đang hoạt động</Text>
                                        <div>
                                            <Title level={3} style={{ margin: 0, color: '#52c41a' }}>
                                                {sponsorPackagesAll.filter((pkg: any) => pkg.status === 'Active').length}
                                            </Title>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 8,
                                        backgroundColor: '#fff1f0',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <TeamOutlined style={{ color: '#f5222d', fontSize: '20px' }} />
                                    </div>
                                    <div>
                                        <Text type="secondary">Đối tác</Text>
                                        <div>
                                            <Title level={3} style={{ margin: 0, color: '#f5222d' }}>
                                                {customers.partners.length}
                                            </Title>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 8,
                                        backgroundColor: '#fff7e6',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <PercentageOutlined style={{ color: '#fa8c16', fontSize: '20px' }} />
                                    </div>
                                    <div>
                                        <Text type="secondary">Giảm giá trung bình</Text>
                                        <div>
                                            <Title level={3} style={{ margin: 0, color: '#fa8c16' }}>
                                                {sponsorPackagesAll.length > 0 ?
                                                    `${(sponsorPackagesAll.reduce((acc: number, code: any) => acc + Number(code.discount), 0) / sponsorPackagesAll.length).toFixed(2)}%`
                                                    : '0%'
                                                }
                                            </Title>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    </Row>

                    <Row gutter={16} style={{ marginBottom: 24 }}>
                        <Col span={4}>
                            <div>
                                <Text strong>Chọn đối tác</Text>
                                <Select
                                    ref={selectSponsorRef}
                                    showSearch
                                    style={{ width: '100%', marginTop: 4 }}
                                    placeholder="Chọn khách hàng"
                                    optionFilterProp="name"
                                    onChange={(value) => setSelectedCustomerDataSponsor(value)}
                                    filterOption={(input: any, option: any) =>
                                        option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    value={selectedCustomerDataSponsor}
                                >
                                    {customers?.partners?.map((customer: any, idx: React.Key) => (
                                        <Select.Option key={idx} value={idx}>
                                            {customer.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </div>
                        </Col>
                        <Col span={4}>
                            <div>
                                <Text strong>Khuyến mãi</Text>
                                <Select
                                    style={{ width: '100%', marginTop: 4 }}
                                    value={promotionType}
                                    onChange={value => setPromotionType(value)}
                                    options={[
                                        { label: 'Tất cả', value: '' },
                                        { label: 'Yes', value: 'Yes' },
                                        { label: 'No', value: 'No' },
                                    ]} />
                            </div>
                        </Col>
                        <Col span={4}>
                            <div>
                                <Text strong>Nhà cung cấp</Text>
                                <Select
                                    style={{ width: '100%', marginTop: 4 }}
                                    value={networkType}
                                    onChange={value => setNetworkType(value)}
                                    options={[
                                        { label: 'Tất cả', value: '' },
                                        { label: 'All', value: 'All' },
                                        ...networks,
                                        ...providerTDMsourceOptions,
                                    ]} />
                            </div>
                        </Col>
                        <Col span={4}>
                            <div>
                                <Text strong>Trạng thái</Text>
                                <Select
                                    style={{ width: '100%', marginTop: 4 }}
                                    value={statusType}
                                    onChange={value => setStatusType(value)}
                                    options={[
                                        { label: 'Tất cả', value: '' },
                                        ...partnerPackageStatusOptions
                                    ]} />
                            </div>
                        </Col>
                        <Col span={3}>
                            <div style={{ marginTop: 24 }}>
                                <Space>
                                    <Button
                                        onClick={() => checkPartnerDataSponsor()}
                                        type="primary"
                                    >
                                        Tìm kiếm
                                    </Button>
                                    <Button
                                        onClick={() => clearEventSponsor()}
                                        icon={<ReloadOutlined />}
                                    >
                                    </Button>
                                </Space>
                            </div>
                        </Col>
                        <Col span={5}>
                            <div style={{ marginTop: 24, textAlign: 'right' }}>
                                <Link to={PARTNERS + PACKAGE_MANAGEMENT + CREATE_PARTNER_SPONSOR + `?cpCode=${customers.partners[Number(selectedCustomerDataSponsor)]?.cpCode}`}>
                                    <Button type="primary">
                                        Thêm gói cước
                                    </Button>
                                </Link>
                            </div>
                        </Col>
                    </Row>

                    {sponsorPackagesFiltered?.length > 0 ? (
                        <div>
                            {sponsorPackagesFiltered?.map((sponsor: any, index: number) => renderSponsorCard(sponsor, index))}
                        </div>
                    ) : (
                        <Card>
                            <div style={{ textAlign: 'center', padding: '40px 0' }}>
                                <Title level={4} type="secondary">
                                    Không tìm thấy gói Data Sponsor
                                </Title>
                                <Text type="secondary">
                                    Cấu hình gói cước Data Sponsor cho đối tác
                                </Text>
                            </div>
                        </Card>
                    )}
                </div>
            ),
        },
        {
            key: 'dataCode',
            label: 'Data code',
            children: (
                <div>
                    <Row gutter={24} style={{ marginBottom: 24 }}>
                        <Col span={6}>
                            <Card>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 8,
                                        backgroundColor: '#e6f7ff',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <TeamOutlined style={{ color: '#1890ff', fontSize: '20px' }} />
                                    </div>
                                    <div>
                                        <Text type="secondary">Tổng số gói</Text>
                                        <div>
                                            <Title level={3} style={{ margin: 0, color: '#1890ff' }}>
                                                {codePackagesAll.length}
                                            </Title>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 8,
                                        backgroundColor: '#f6ffed',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <TeamOutlined style={{ color: '#52c41a', fontSize: '20px' }} />
                                    </div>
                                    <div>
                                        <Text type="secondary">Gói đang hoạt động</Text>
                                        <div>
                                            <Title level={3} style={{ margin: 0, color: '#52c41a' }}>
                                                {codePackagesAll.filter((pkg: any) => pkg.status === 'Active').length}
                                            </Title>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 8,
                                        backgroundColor: '#fff1f0',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <TeamOutlined style={{ color: '#f5222d', fontSize: '20px' }} />
                                    </div>
                                    <div>
                                        <Text type="secondary">Đối tác</Text>
                                        <div>
                                            <Title level={3} style={{ margin: 0, color: '#f5222d' }}>
                                                {customers.partners.length}
                                            </Title>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 8,
                                        backgroundColor: '#fff7e6',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <PercentageOutlined style={{ color: '#fa8c16', fontSize: '20px' }} />
                                    </div>
                                    <div>
                                        <Text type="secondary">Giảm giá trung bình</Text>
                                        <div>
                                            <Title level={3} style={{ margin: 0, color: '#fa8c16' }}>
                                                {codePackagesAll.length > 0 ?
                                                    `${(codePackagesAll.reduce((acc: number, code: any) => acc + Number(code.discount), 0) / codePackagesAll.length).toFixed(2)}%`
                                                    : '0%'
                                                }
                                            </Title>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    </Row>

                    <Row gutter={16} style={{ marginBottom: 24 }}>
                        <Col span={4}>
                            <div>
                                <Text strong>Chọn đối tác</Text>
                                <Select
                                    ref={selectCodeRef}
                                    showSearch
                                    style={{ width: '100%', marginTop: 4 }}
                                    placeholder="Chọn khách hàng"
                                    optionFilterProp="name"
                                    onChange={(value) => setSelectedCustomerDataCode(value)}
                                    filterOption={(input: any, option: any) =>
                                        option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    value={selectedCustomerDataCode}
                                >
                                    {customers?.partners?.map((customer: any, idx: React.Key) => (
                                        <Select.Option key={idx} value={idx}>
                                            {customer.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </div>
                        </Col>
                        <Col span={4}>
                            <div>
                                <Text strong>Trạng thái</Text>
                                <Select
                                  style={{ width: '100%', marginTop: 4 }}
                                  value={statusTypeCode}
                                  onChange={value => setStatusTypeCode(value)}
                                  options={[
                                      { label: 'Tất cả', value: '' },
                                      ...partnerPackageStatusOptions
                                  ]} />
                            </div>
                        </Col>
                        <Col span={6}>
                            <div style={{ marginTop: 24 }}>
                                <Space>
                                    <Button
                                        onClick={() => checkPartnerDataCode()}
                                        type="primary"
                                    >
                                        Tìm kiếm
                                    </Button>
                                    <Button
                                        onClick={() => clearEventCode()}
                                        icon={<ReloadOutlined />}
                                    >
                                    </Button>
                                </Space>
                            </div>
                        </Col>
                        <Col span={10}>
                            <div style={{ marginTop: 24, textAlign: 'right' }}>
                                <Link to={PARTNERS + PACKAGE_MANAGEMENT + CREATE_PARTNER_CODE + `?cpCode=${customers.partners[Number(selectedCustomerDataCode)]?.cpCode}`}>
                                    <Button type="primary">
                                        Thêm gói cước
                                    </Button>
                                </Link>
                            </div>
                        </Col>
                    </Row>

                    {codePackagesFiltered.length > 0 ? (
                        <div>
                            {codePackagesFiltered.map((code: any, index: number) => renderCodeCard(code, index))}
                        </div>
                    ) : (
                        <Card>
                            <div style={{ textAlign: 'center', padding: '40px 0' }}>
                                <Title level={4} type="secondary">
                                    Không tìm thấy gói Data Code
                                </Title>
                                <Text type="secondary">
                                    Cấu hình gói cước Data Code cho đối tác
                                </Text>
                            </div>
                        </Card>
                    )}
                </div>
            ),
        },
    ]

    return (
        <div>
            <Tabs type='card' defaultActiveKey={previousTab || 'dataSponsor'} items={itemsTab} />
            <ViewPartnerSponsor
                modalView={modalViewSponsor}
                setModalView={setModalViewSponsor}
            />
            <ViewPartnerCode
                modalView={modalViewCode}
                setModalView={setModalViewCode}
            />
        </div>
    )
}
